import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useMemberColumns } from "@/pages/payment/hooks/useMemberColumns";
import { usePaymentStore } from "../../store/payment-store";
import { RechargeRecordTabType } from "../../constants";
import { useEffect } from "react";

export function MemberRechargeRecord() {
  const { tableData, pageNum, fetchData, setPageNum, total, pageSize } =
    useDynamicForm({
      api: "/api/rendering/pay/recharge/queryMemberRecharges",
      defaultPageSize: 10,
    });

  useWatchPagination(pageSize, pageNum, fetchData);

  const { columns } = useMemberColumns();
  const { activeTabKey } = usePaymentStore();

  useEffect(() => {
    if (activeTabKey === RechargeRecordTabType.Member) {
      fetchData();
    }
  }, [activeTabKey, fetchData]);

  return (
    <PageContainer>
      <TableContainer>
        <Table
          paginationCurrent={pageNum}
          columns={columns}
          dataSource={tableData}
          gap={false}
          total={total}
          defaultPageSize={pageSize}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </PageContainer>
  );
}
